import apiClient from './apiClient';
import type { NoteTemplate } from '../types/noteTemplate.types';

export const list = async (): Promise<NoteTemplate[]> => {
  const response = await apiClient.get<NoteTemplate[]>('/note-templates');
  return response.data;
};

export const create = async (input: { label: string; body: string }): Promise<NoteTemplate> => {
  const response = await apiClient.post<NoteTemplate>('/note-templates', input);
  return response.data;
};

export const update = async (id: string, patch: Partial<{ label: string; body: string }>): Promise<NoteTemplate> => {
  const response = await apiClient.put<NoteTemplate>(`/note-templates/${encodeURIComponent(id)}`, patch);
  return response.data;
};

export const remove = async (id: string): Promise<void> => {
  await apiClient.delete(`/note-templates/${encodeURIComponent(id)}`);
};

export default { list, create, update, remove };
